import React from "react";
import { Modal, Button } from "react-bootstrap";
import Lottie from "lottie-react";
import successAnimation from "../../assets/animations/Success.json";

const DDPaidSuccessfully = ({
    show,
    onHide,
    companyName,
    employeeCount,
    totalAmount,
}) => {
    const formatMoney = (v) =>
        v !== null && v !== undefined ? `$${Number(v).toLocaleString()}` : "$0";

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            keyboard={false}
            dialogClassName="dd-success-modal"
            className="dd_paid_success_popup"
        >
            <Modal.Body>
                <div className="dd-success-wrapper">
                    <div className="dd-success-icon">
                        <Lottie
                            animationData={successAnimation}
                            loop={true}
                            style={{ width: 100, height: 100 }}
                        />
                    </div>

                    <h4 className="dd-success-title">DD Paid Successfully</h4>

                    <p className="dd-success-text">
                        <strong>{companyName}</strong> has successfully processed direct
                        deposit for <strong>{employeeCount}</strong> employees.
                    </p>

                    <div className="dd-success-amount">
                        Total Amount: <span>{formatMoney(totalAmount)}</span>
                    </div>

                    <Button className="dd-success-btn btn_primary" onClick={onHide}>
                        Close
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DDPaidSuccessfully;
